import {NAME_SPACE} from "@kta20-core/constants";

export const MODULE_CLASS_NAME = 'KnowledgeBaseModule';

export enum ViewNames {
    KB_MAIN_VIEW='kta20-kb-main-view',
    KB_DOCUMENT_RECORD_DETAIL_VIEW='kta20-kb-document-record-detail-view',
    KB_RECORD_DETAILS_VIEW='kta20-kb-record-details-view',
    KB_DEMO_CARD_VIEW='kta20-kb-demo-card-view',
}

export const KB_SEARCH_KEY:string=`${NAME_SPACE}.kb-search-key`;
export const KB_SEARCH_RECORDS:string=`${NAME_SPACE}.kb-search-records`;
export const KB_SEARCH_RECORD_DETAIL:string=`${NAME_SPACE}.kb-search-record-detail`;
export const KB_RECORD_TYPE_CONFIG:string=`${NAME_SPACE}.kb-record-type-config`;